import {
  CheckboxComponent,
  TableComponent,
} from "deinestadtliebt-component-library";
import { useTranslation } from "react-i18next/";
import { Action } from "../../../utils/action/Action.types";
import { DateState } from "../../../utils/activity/Activity.types";
import { Event } from "../../../utils/event/Event.types";
import { generateSoldOutTableRows } from "../../../utils/state/StateUtils";

interface SoldOutComponentProps {
  activityToEdit: Event | Action | undefined;
  handleDateStateChange: Function;
}

const SoldOutComponent: React.FC<SoldOutComponentProps> = ({
  activityToEdit,
  handleDateStateChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <h4>{t("adminEventPage.status.multiSold")}</h4>
      <div className="cancel-wrapper">
        {!!activityToEdit?.startDate ? (
          <>
            <div className="activity-date">
              {new Date(
                activityToEdit.startDate || new Date()
              ).toLocaleDateString("de")}
              {!!activityToEdit?.endDate ? (
                <>
                  {" - "}
                  {new Date(
                    activityToEdit.endDate || new Date()
                  ).toLocaleDateString("de")}
                </>
              ) : (
                <></>
              )}
            </div>
            <CheckboxComponent
              value=""
              checked={
                !!activityToEdit?.activityDates &&
                activityToEdit?.activityDates?.[0]?.state === DateState.SOLD_OUT
              }
              onCheck={() => {
                handleDateStateChange(0, DateState.SOLD_OUT);
              }}
            />
          </>
        ) : (
          <div className="soldout-wrapper--table">
            <TableComponent
              rows={generateSoldOutTableRows(
                activityToEdit!,
                handleDateStateChange
              )}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SoldOutComponent;
